<template>
  <div class="info-tab-wrapper" :style="'height: '+ (wHeight-86) + 'px'">
    <v-card
      flat
      class="mb-2 text-center overflow-x-hidden overflow-y-auto info-scroll"
      :style="'height: '+ (wHeight-92) + 'px'"
    >
      <!-- Hero carousel -->
      <div v-if="!settings.options.carouselImages" class="d-flex justify-center align-center" style="height:280px">
        <v-progress-circular indeterminate size="64" width="5" color="black"></v-progress-circular>
      </div>

      <div v-else class="hero-carousel-wrap">
        <div class="hero-carousel-ratio">
          <v-carousel
            cycle
            continuous
            interval="3000"
            height="100%"
            hide-delimiter-background
            show-arrows-on-hover
            hide-delimiters
          >
          <v-carousel-item
            v-for="(item, i) in settings.options.carouselImages.split(',')"
            :key="i"
            :src="'/static/users/pictures/slides/' + item"
            :class="{ 'clickable-slide': isDesktop }"
            @click="openFullscreenCarousel(i)"
          />
        </v-carousel>
        </div>
        <!-- Rating badge floating on hero -->
        <div v-if="userDetails && userDetails.avgScore" class="rating-badge">
          <v-icon size="16" color="amber darken-1" class="mr-1">mdi-star</v-icon>
          <span class="font-weight-bold">{{ Number(userDetails.avgScore).toFixed(1) }}</span>
          <span v-if="userDetails.reviewCount" class="grey--text text--darken-1 ml-1">({{ userDetails.reviewCount }})</span>
        </div>
      </div>

      <div class="px-3 pt-4">

        <!-- Expired service -->
        <v-card v-if="expired && expired.expired==1" flat class="text-center pa-5 mb-3 status-card status-card--error">
          <v-icon color="white" size="32" class="mb-2">mdi-alert-circle</v-icon>
          <div class="text-h6 white--text font-weight-bold">{{$t(page+'.Restaurant Account Deactivated')}}</div>
          <div class="text-body-2 white--text mt-1">{{$t(page+'.Please contact us directly via phone')}}</div>
        </v-card>

        <template v-else>
          <v-card v-if="bookableDays && !bookableDays.find(d=>d.date==booking.date) && booking.date" flat class="text-center pa-5 mb-3 status-card status-card--warning">
            <v-icon color="white" size="28" class="mb-1">mdi-calendar-remove</v-icon>
            <div class="text-body-1 white--text font-weight-bold">{{$t(page+'.Sorry, reservation Expired')}}</div>
          </v-card>

          <!-- Restaurant info card -->
          <v-card flat class="info-card mb-3 text-left">
            <!--<div class="caption text-center">{{ customer?customer.customerId:'' }}</div>-->
            <div
              class="info-row"
              v-if="settings.options.infopage_address"
              :style="settings.options.WA_message_booking_reminder_gmap ? 'cursor:pointer' : ''"
              @click="settings.options.WA_message_booking_reminder_gmap && openGmap()"
            >
              <div class="info-icon"><v-icon :size="$vuetify.breakpoint.lgAndUp?36:18" color="info">mdi-map-marker</v-icon></div>
              <div :class="$vuetify.breakpoint.lgAndUp ? 'text-h6' : 'text-body-2'" style="flex:1">{{ settings.options.infopage_address }}</div>
              <!--<v-icon v-if="settings.options.WA_message_booking_reminder_gmap" small color="grey darken-1">mdi-open-in-new</v-icon>-->
            </div>
            <v-divider class="fw" v-if="settings.options.infopage_address"></v-divider>

            <div class="info-row" v-if="settings.options.infopage_cuisine">
              <div class="info-icon"><v-icon :size="$vuetify.breakpoint.lgAndUp?36:18" color="black">mdi-silverware-fork-knife</v-icon></div>
              <div :class="$vuetify.breakpoint.lgAndUp ? 'text-h6' : 'text-body-2'">{{settings.locale== 'it'? settings.options.infopage_cuisine:settings.options.infopage_cuisine_en }}</div>
            </div>
            <v-divider class="fw" v-if="settings.options.infopage_cuisine"></v-divider>

            <!-- Price + payment methods -->
            <div class="info-row" v-if="settings.options.infopage_averagePrice||(acceptedMops && acceptedMops.length)">
              <div class="info-icon" v-if="settings.options.infopage_averagePrice">
                <v-icon :size="$vuetify.breakpoint.lgAndUp?36:18" color="black">mdi-cash</v-icon>
              </div>
              <div class="flex-grow-1 d-flex align-center justify-space-between flex-wrap" style="gap:8px">
                <div :class="$vuetify.breakpoint.lgAndUp ? 'text-h6' : 'text-body-2'" v-if="settings.options.infopage_averagePrice">
                  {{$t(page+'.Average Price')}}: {{ settings.options.infopage_averagePrice }} €
                </div>
                <div class="d-flex align-center" v-if="acceptedMops && acceptedMops.length">
                  <v-img
                    v-for="mop in acceptedMops"
                    :key="mop"
                    :src="`/static/users/pictures/payments/${mop}.svg`"
                    :alt="mop"
                    :height="$vuetify.breakpoint.lgAndUp?33:22"
                    :width="$vuetify.breakpoint.lgAndUp?75:50"
                    contain
                    class="mr-1 payment-icon"
                  />
                </div>
              </div>
            </div>
            <v-divider class="fw" v-if="settings.options.infopage_averagePrice||(acceptedMops && acceptedMops.length)"></v-divider>

            <!-- Opening days: compact dot grid, not checkboxes -->
            <div class="info-row" v-if="settings.options.infopage_timetable||settings.options.infopage_timetable_en">
              <div class="info-icon"><v-icon :size="$vuetify.breakpoint.lgAndUp?36:18" color="black">mdi-calendar-today</v-icon></div>
              <div :class="$vuetify.breakpoint.lgAndUp ? 'text-h6' : 'text-body-2'">{{ settings.locale=='it'?settings.options.infopage_timetable:settings.options.infopage_timetable_en }}</div>
            </div>
            <v-divider class="fw" v-if="settings.options.infopage_timetable||settings.options.infopage_timetable_en"></v-divider>

            <div class="info-row" v-if="settings.options.infopage_reservation_required">
              <div class="info-icon"><v-icon :size="$vuetify.breakpoint.lgAndUp?36:18" color="black">mdi-book-edit</v-icon></div>
              <div :class="$vuetify.breakpoint.lgAndUp ? 'text-h6' : 'text-body-2'">{{$t(page+'.Reservation')}}: {{ settings.options.infopage_reservation_required=='0'?$t(page+'.Suggested'):$t(page+'.Required') }}</div>
            </div>
            <v-divider class="fw" v-if="settings.options.infopage_reservation_required"></v-divider>

            <div class="info-row" v-if="settings.options.infopage_takeaway">
              <div class="info-icon"><v-icon :size="$vuetify.breakpoint.lgAndUp?36:18" color="black">mdi-food-takeout-box</v-icon></div>
              <div :class="$vuetify.breakpoint.lgAndUp ? 'text-h6' : 'text-body-2'">Take-Away: {{ settings.options.infopage_takeaway=='1'?$t(page+'.Available'):$t(page+'.Not Available') }}</div>
            </div>

          </v-card>

          <!-- DB custom buttons -->
          <div v-if="!expired || expired.expired!=1" class="mb-3">
            <v-btn
              block
              large
              height="36px"
              v-if="settings.options.DBFirstButtonURL && settings.options.DBFirstButtonEnabled && new Date(settings.options.DBFirstButtonEnabled) > new Date()"
              outlined
              color="black"
              class="mb-2 custom-action-btn"
              :href="settings.options.DBFirstButtonURL"
            >
              {{settings.options.DBFirstButtonTitle}}
            </v-btn>
            <v-btn
              block
              large
              height="36px"
              v-if="settings.options.DBSecondButtonURL && settings.options.DBSecondButtonEnabled && new Date(settings.options.DBSecondButtonEnabled) > new Date()"
              outlined
              color="black"
              class="custom-action-btn"
              :href="settings.options.DBSecondButtonURL"
            >
              {{settings.options.DBSecondButtonTitle}}
            </v-btn>
          </div>
        </template>
      </div>
      <div>
        <v-carousel
          v-if="advertisers && advertisers.length"
          v-model="advertiserCarousel"
          cycle
          continuous
          interval="3000"
          hide-delimiters
          :show-arrows="false"
          :height="carouselHeight"
          class="px-3"
        >
          <v-carousel-item
            v-for="(item, i) in advertisers"
            :key="'fs-' + i"
            :class="{ 'clickable-slide': isDesktop }"
          >
            <v-sheet :color="item.color" height="100%" @click.stop="openAdvertiser(item)">
              <v-img
                :src="`/static/users/pictures/advertisers/${item.logo}`"
                contain
                height="100%"
              />
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
        <div class="text-caption mt-3">Vuoi pubblicizzare la tua azienda qui? <br /><a href="https://wa.me/393208443389">Contattaci</a></div>          
      </div>
    </v-card>

    <!-- Bottom CTA -->
    <!--
    <div v-if="(!expired || expired.expired!=1) && !hideCta" class="bottom-button-container2">
      <v-btn
        block
        large
        rounded
        style="height: 56px;"
        :loading="loading"
        outlined
        @click="openBookings && openBookings.length ? $emit('manage-reservations') : $emit('change-tab', 4)"
      >
        <span>
          <div v-if="customer&&customer.firstName" class="mb-1">
            {{greeting}} {{customer.firstName}}!
          </div>
          <div v-if="this.openBookings">
            {{ $t(page + '.Manage Reservations') }}
          </div>
          <div v-else>
            {{ $t(page + '.Book a Table') }}
          </div>
        </span>
      </v-btn>
    </div>
    -->
   <div v-if="(!expired || expired.expired!=1) && !hideCta" class="bottom-button-container2">
      <v-btn
        block
        large
        rounded
        height="36px"
        :loading="loading"
        outlined
        @click="openBookings && openBookings.length ? $emit('manage-reservations') : $emit('change-tab', 4)"
      >
        <span>
          <!--
          <div v-if="customer&&customer.firstName" class="mb-1">
            {{greeting}} {{customer.firstName}}!
          </div>
          -->
          <div v-if="openBookings && openBookings.length">
            {{ $t(page + '.Manage Reservations') }}
          </div>
          <div v-else>
            {{ $t(page + '.Book a Table') }}
          </div>
        </span>
      </v-btn>

      <!-- Recover Account CTA -->
      <v-btn
        v-if="(!expired || expired.expired!=1) && !(openBookings && openBookings.length) && (customer && !customer.validated)"
        block
        large
        rounded
        height="36px"
        outlined
        color="info"
        class="mt-2 recover-cta-btn"
        @click="openRecoverDialog()"
      >
        <v-icon left>mdi-account-key-outline</v-icon>
        {{ $t(page+'.Manage your Reservations') }}
      </v-btn>
    </div>

    <!-- Recover Account CTA — desktop only (hideCta hides the container above) -->
    <div v-if="(!expired || expired.expired!=1) && !(openBookings && openBookings.length) && (customer && !customer.validated) && hideCta" class="bottom-button-container2">
      <v-btn
        block
        large
        rounded
        height="36px"
        outlined
        color="info"
        class="recover-cta-btn"
        @click="openRecoverDialog()"
      >
        <v-icon left>mdi-account-key-outline</v-icon>
        {{ $t(page+'.Manage your Reservations') }}
      </v-btn>
    </div>

    <!-- ─── RECOVER ACCOUNT DIALOG ──────────────────────────────── -->
    <v-dialog v-model="dialog_recover" max-width="420" scrollable>
      <v-card outlined class="recover-dialog">

        <!-- Dynamic header per step -->
        <v-card-title class="recover-dialog__title">
          <template v-if="recoverStep === 1">
            <v-icon class="mr-2" color="info">mdi-account-key-outline</v-icon>
            <span class="text-subtitle-1 font-weight-bold">{{ $t(page+'.Manage your Reservations') }}</span>
          </template>
          <template v-else-if="recoverStep === 2">
            <v-icon class="mr-2" color="green darken-1">mdi-whatsapp</v-icon>
            <span class="text-subtitle-1 font-weight-bold">{{ $t(page+'.Enter OTP') || 'Enter OTP' }}</span>
          </template>
          <template v-else-if="recoverStep === 3">
            <v-icon class="mr-2" color="success">mdi-check-circle-outline</v-icon>
            <span class="text-subtitle-1 font-weight-bold">{{ $t(page+'.Done') || 'Done' }}</span>
          </template>
          <template v-else-if="recoverStep === 4">
            <v-icon class="mr-2" color="error">mdi-alert-circle-outline</v-icon>
            <span class="text-subtitle-1 font-weight-bold">{{ $t(page+'.Error') || 'Error' }}</span>
          </template>
          <v-spacer></v-spacer>
          <v-btn icon small @click="closeRecoverDialog()"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <!-- Step dots indicator -->
        <div class="recover-dialog__steps">
          <span
            v-for="n in 2" :key="n"
            class="recover-dialog__dot"
            :class="{ 'recover-dialog__dot--active': recoverStep === n, 'recover-dialog__dot--done': recoverStep > n }"
          ></span>
        </div>

        <v-divider class="fw"></v-divider>

        <v-card-text class="px-4 pt-4 pb-4">

          <!-- Step 1: Enter phone -->
          <template v-if="recoverStep === 1">
            <div class="recover-dialog__hint mb-4">
              <v-icon small color="grey darken-1" class="mr-1">mdi-information-outline</v-icon>
              <span class="text-caption grey--text text--darken-1">
                {{ $t(page+'.View or manage your booking using your WhatsApp number') }}
              </span>
            </div>

            <div class="align-start" style="gap:8px">
              <!-- Country code — narrow -->
              <v-row>
                <v-col>
              <v-select
                color="black" dense outlined
                v-model="recoverCountryCode"
                :items="countries"
                hide-details
                item-value="value"
                :item-text="item => '+'+item.value"
              >
                <template v-slot:item="slotProps">
                  <i :class="['mr-2','em',slotProps.item.flag]"></i>
                  {{slotProps.item.namel}} +{{slotProps.item.value}}
                </template>
                <template v-slot:selection="data">
                  <i :class="['mr-1','em',data.item.flag]"></i>
                  <span class="text-body-2">+{{data.item.value}}</span>
                </template>
              </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
              <v-text-field
                v-model="recoverPhone"
                :label="$t(page+'.WhatsApp number') || 'WhatsApp number'"
                outlined dense
                append-icon="mdi-whatsapp"
                hide-details
                type="tel"
                v-mask="'### ### ## ##'"
                style="flex:1"
              ></v-text-field>                  
                </v-col>
              </v-row>

              <!-- Phone number — fills remaining width -->

            </div>

            <v-btn
              block color="black" dark class="mt-4"
              style="border-radius:10px"
              :disabled="!recoverPhone || recoverPhone.replace(/\s/g,'').length < 9"
              :loading="recoverLoading"
              @click="recoverSendOtp()"
            >
              <v-icon small left>mdi-whatsapp</v-icon>
              {{ $t(page+'.Get OTP') || 'Send OTP via WhatsApp' }}
            </v-btn>
          </template>

          <!-- Step 2: Enter OTP -->
          <template v-else-if="recoverStep === 2">
            <v-alert dense text color="green darken-1" icon="mdi-whatsapp" class="text-body-2 mb-4">
              {{ $t(page+'.OTP sent to') || 'Code sent to' }}
              <strong>+{{ recoverCountryCode }} {{ recoverPhone }}</strong>
            </v-alert>

            <v-text-field
              v-model="recoverOtp"
              :label="$t(page+'.Enter OTP code 9 digits') || 'Enter the 9-digit code'"
              outlined
              dense
              type="text"
              inputmode="numeric"
              autocomplete="one-time-code"
              placeholder="000-000-000"
              v-mask="'###-###-###'"
              :maxlength="11" :minlength="11"
              :loading="recoverLoading"
              :hint="recoverOtpError || $t(page+'.Check your WhatsApp')"
              :error="!!recoverOtpError"
              :success="!recoverOtpError && !!recoverOtp && recoverOtp.length === 11"
              persistent-hint
              prepend-inner-icon="mdi-shield-key"
              @input="recoverOnOtpInput"
            ></v-text-field>

            <v-btn small text class="mt-2 px-0" @click="recoverStep = 1; recoverOtp = ''; recoverOtpError = ''">
              <v-icon left small>mdi-arrow-left</v-icon>
              {{ $t(page+'.Back') || 'Change number' }}
            </v-btn>
          </template>

          <!-- Step 3: Success -->
          <template v-else-if="recoverStep === 3">
            <div class="text-center py-6">
              <v-icon color="success" size="80">mdi-check-circle-outline</v-icon>
              <p class="text-h6 mt-4 mb-1">{{ recoverSuccessMsg }}</p>
              <p class="text-caption grey--text">{{ $t(page+'.Reloading') || 'Reloading…' }}</p>
              <v-progress-linear indeterminate color="success" rounded class="mt-4" style="max-width:160px;margin:auto"></v-progress-linear>
            </div>
          </template>

          <!-- Step 4: Failed -->
          <template v-else-if="recoverStep === 4">
            <div class="text-center py-6">
              <v-icon color="error" size="80">mdi-close-circle-outline</v-icon>
              <p class="text-body-1 mt-4 font-weight-medium error--text">{{ recoverOtpError }}</p>
              <v-btn
                outlined color="black" class="mt-4" style="border-radius:10px"
                @click="recoverStep = 1; recoverOtp = ''; recoverOtpError = ''"
              >
                <v-icon left small>mdi-refresh</v-icon>
                {{ $t(page+'.Try Again') || 'Try Again' }}
              </v-btn>
            </div>
          </template>

        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Advertiser iframe dialog -->
    <v-dialog v-model="dialog_advertiser" fullscreen transition="fade-transition">
      <v-card tile class="advertiser-iframe-card">
        <v-btn icon class="advertiser-iframe-close" @click="dialog_advertiser = false; advertiserIframeUrl = null">
          <v-icon size="28" color="white">mdi-close</v-icon>
        </v-btn>
        <iframe v-if="advertiserIframeUrl" :src="advertiserIframeUrl" frameborder="0" class="advertiser-iframe" allow="fullscreen"></iframe>
      </v-card>
    </v-dialog>

    <!-- Fullscreen carousel (desktop only — triggered via openFullscreenCarousel) -->
    <v-dialog v-model="dialog_fullscreenCarousel" fullscreen transition="fade-transition">
      <v-card tile dark class="fullscreen-carousel-card">
        <v-btn
          icon
          class="fullscreen-carousel-close"
          @click="dialog_fullscreenCarousel = false"
        >
          <v-icon size="28" color="white">mdi-close</v-icon>
        </v-btn>

        <v-carousel
          v-if="dialog_fullscreenCarousel"
          v-model="fullscreenCarouselIndex"
          height="100%"
          show-arrows
          hide-delimiter-background
        >
          <v-carousel-item
            v-for="(item, i) in settings.options.carouselImages.split(',')"
            :key="'fs-'+i"
            :src="'/static/users/pictures/slides/'+item"
            contain
          />
        </v-carousel>
      </v-card>
    </v-dialog>      
  </div>
</template>

<script>
import { mapGetters } from "vuex";


export default {
  props: {
    hideCta: {
      type: Boolean,
      default: false
    }
  },  
  data() {
    return {
      page: 'Booking',
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      contentHeight: 0,
      mainTab: 0,
      snackbar: {
        active: false,
        color: 'success',
        text: ''
      },
      carouselImages: null,
      booking: { "origin": null, "date": null },
      sessionId: null,
      bookingId: null,
      customerId: null,
      customer: null,
      loading: false,
      expired: null,
      bookableDays: null,
      openBookings: null,
      userDetails: null,
      lunch: [],
      dinner: [],
      dialog_fullscreenCarousel: false,
      fullscreenCarouselIndex: 0,
      advertiserCarousel:1,
      advertisers: null,
      dialog_advertiser: false,
      advertiserIframeUrl: null,

      // Recover account dialog
      dialog_recover: false,
      recoverStep: 1,
      recoverLoading: false,
      recoverPhone: '',
      recoverCountryCode: 39,
      recoverOtp: '',
      recoverOtpError: '',
      recoverOtpReady: false,
      recoverSuccessMsg: '',

      // NOTE: removed the static `days` array that used to live here —
      // it duplicated the computed `days` below and was silently winning
      // over it (Vue always prefers a data property over a computed
      // property of the same name), which meant the locale-aware day
      // labels were never actually being used.
    }
  },

  computed: {
    ...mapGetters(['settings', 'countries']),
    carouselHeight() {
      // Accessing Vuetify 2 breakpoints
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 90
        case 'sm': return 120
        case 'md': return 160
        case 'lg': return 200
        case 'xl': return 240
        default:   return 90
      }
    },    
    greeting() {
      const hour = new Date().getHours()
      return hour < 16 ? this.$t(this.page + '.Good Morning') : this.$t(this.page + '.Good Evening')
    },
    acceptedMops() {
      const rawString = this.settings?.options?.infopage_accepted_mop;

      // 1. Guard against empty values
      if (!rawString) return [];

      // 2. If it's already an array, return it directly
      if (Array.isArray(rawString)) return rawString;

      // 3. Split by comma, trim whitespace, and clear empty values
      if (typeof rawString === "string") {
        return rawString
          .split(",")
          .map((item) => item.trim())
          .filter(Boolean);
      }

      return [];
    },
    isDesktop() {
      return this.$vuetify.breakpoint.lgAndUp
    },    
  },

  async created() {
    sessionStorage.removeItem('jwt')
    sessionStorage.removeItem('csrf')
    sessionStorage.removeItem('settings')

    const locale = window.navigator.userLanguage || window.navigator.language
    this.settings.locale = locale.substring(0, 2)
    this.$store.dispatch('setLocale', locale.substring(0, 2))

    this.booking.origin = this.$route.path || '/db'
    this.bookingId = this.$route.query.p

    if (this.$route.query && this.$route.query.q) {
      this.sessionId = this.$route.query.q.split('/?')[0]
    }

    await this.detectUser()
  },

  mounted() {
    this.calculateContentHeight()
    window.addEventListener('resize', this.calculateContentHeight)
    window.addEventListener('orientationchange', this.calculateContentHeight)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.calculateContentHeight)
    window.removeEventListener('orientationchange', this.calculateContentHeight)
  },

  methods: {
    openGmap() {
      const placeId = this.settings?.options?.infopage_google_place_id
      if (placeId) { //https://maps.app.goo.gl/38R95UDyrRB1v5kq8
        const api_key='AIzaSyC0ZecEEVyglbrcd27vMmSzwdktOCM1Eyo';
        const gmapUrl='https://www.google.com/maps/embed/v1/place?key='+api_key+'&q=place_id:'+placeId;
        console.log('Opening Google Maps iframe with URL:', gmapUrl)
        this.advertiserIframeUrl = gmapUrl
        this.dialog_advertiser = true
      }
    },
    openFullscreenCarousel(index) {
      if (!this.isDesktop) return
      this.fullscreenCarouselIndex = index
      this.dialog_fullscreenCarousel = true
    },
    async openAdvertiser(item) {
      if (!item || !item.url) return
      const base = /^https?:\/\//i.test(item.url) ? item.url : (window.location.origin + item.url)
      const u = new URL(base)
      if (item.fieldName) u.searchParams.set(item.fieldName, item.token)
      this.advertiserIframeUrl = u.toString()
      this.dialog_advertiser = true
      try {
        const deviceInfo = this.getDeviceInfo()
        await this.$http.post('/booking/booking_stepper.php', {
          action: 'advertiserClick',
          payload: {
            brand:         item.brand || item.logo || null,
            token:         item.token || null,
            url:           this.advertiserIframeUrl,
            locale:        this.settings.locale,
            screenWidth:   deviceInfo.screen.screenWidth,
            screenHeight:  deviceInfo.screen.screenHeight,
            viewportWidth: deviceInfo.screen.viewportWidth,
            viewportHeight:deviceInfo.screen.viewportHeight,
            OS:            deviceInfo.os,
            customerId:    this.customer.customerId,
            accountId:     this.settings.accountId,
          }
        })
      } catch (e) {
        console.error('Failed to log advertiser click', e)
      }
    },    
    /*
    parseOpeningHours(str) {
      try {
        const obj = JSON.parse(str.replace(/'/g, '"'))
        return { lunch: obj.lunch || [], dinner: obj.dinner || [] }
      } catch (e) {
        console.error('Failed to parse opening hours', e)
        return { lunch: [], dinner: [] }
      }
    },
    */
    calculateContentHeight() {
      this.wHeight = window.innerHeight
      const appBar = document.querySelector('.v-app-bar')
      const appBarHeight = appBar ? appBar.offsetHeight : 0
      const systemBar = document.querySelector('.v-system-bar')
      const systemBarHeight = systemBar ? systemBar.offsetHeight : 0
      const tabsHeader = document.querySelector('.tabs-header-fixed')
      const tabsHeaderHeight = tabsHeader ? tabsHeader.offsetHeight : 0
      const buttonHeight = 72
      this.contentHeight = this.wHeight - appBarHeight - systemBarHeight - tabsHeaderHeight - buttonHeight - 8
      if (this.contentHeight < 300) this.contentHeight = 300
    },
    getOS() {
          // Modern browsers (User Agent Client Hints)
          if (navigator.userAgentData && navigator.userAgentData.platform) {
            return navigator.userAgentData.platform
          }

          // Fallback for older browsers
          const userAgent = window.navigator.userAgent.toLowerCase()
          if (userAgent.indexOf('win') !== -1) return 'Windows'
          if (userAgent.indexOf('mac') !== -1) return 'macOS'
          if (userAgent.indexOf('android') !== -1) return 'Android'
          if (userAgent.indexOf('like mac') !== -1 || userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) return 'iOS'
          if (userAgent.indexOf('linux') !== -1) return 'Linux'

          return 'Unknown OS'
        },

        // 2. Gather Device Info
        getDeviceInfo() {
          return {
            os: this.getOS(),
            screen: {
              // Hardware monitor resolution
              screenWidth: window.screen.width,
              screenHeight: window.screen.height,
              // Active browser viewport size
              viewportWidth: window.innerWidth,
              viewportHeight: window.innerHeight,
              // Vuetify 2 reactive breakpoint (xs, sm, md, lg, xl)
              breakpoint: this.$vuetify.breakpoint.name
            },
            // Optional: track if launched as installed PWA standalone app
            isPWA: window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
          }
        },
    async detectUser(a=0) {
      if (this.loading) return
      this.loading = true
      try {
        this.customerId = localStorage.getItem('customerId')
        const hostname = window.location.hostname
        //const pload = this.getDeviceInfo()
        const payload = {
          action: 'identifyAccount',
          payload: {
            hostname: hostname,
            customerId: this.customerId,
            locale: this.settings.locale,
            bookingId: this.bookingId,
            sessionId: this.sessionId,
            ...this.getDeviceInfo()
          }
        }

        const res = await this.$http.post('/booking/booking_stepper.php', payload)
        this.loading = false

        if (res.data.errorid === '0') {
          this.$store.dispatch('setSettings', res.data.payloads.settings)
          console.log('728 - res',res)
          
          this.customer = res.data.payloads.customer
          this.customer.appValidated=res.data.payloads.appValidated;
          //console.log('733 - this.customer',this.customer)
          //this.$emit('customer-updated', this.customer);
          if (this.customer && this.customer.customerId) {
            localStorage.setItem('customerId', this.customer.customerId)
          }
          

          this.expired = res.data.payloads.expired || null
          this.advertisers = res.data.payloads.advertisers || null
          this.$emit('advertisers-loaded', this.advertisers)
          this.bookableDays = res.data.payloads.bookableDays || null
          this.carouselImages = res.data.payloads.settings.options.carouselImages
          this.userDetails = res.data.payloads.userDetails || null

          /*
          const raw = this.settings.options.infopage_opening_days
          const parsed = this.parseOpeningHours(raw)
          this.lunch = parsed.lunch
          this.dinner = parsed.dinner
          */

          this.openBookings = res.data.payloads.openBookings || null
          this.$emit('open-bookings-loaded', this.openBookings)
          this.$emit('customer-updated', this.customer);

          // Auto-switch to BookingTab step 30 when customer arrives via booking link
          if (this.openBookings && this.bookingId && String(this.bookingId).length === 40 || a==1) {
            this.$emit('manage-reservations')
          }          

          this.$nextTick(() => {
            this.calculateContentHeight()
          })
        }
        else
        {
          this.showError('Authentication failed')
          this.$router.push('/unknown').catch(() => {});
        }
      } catch (error) {
        console.error('Authentication error:', error)
        this.showError('Connection error')
        this.loading = false
      } finally {
        this.$emit('detect-user-finished')
      }
    },

    showError(message) {
      this.snackbar = { active: true, color: 'error', text: message }
    },

    showSuccess(message) {
      this.snackbar = { active: true, color: 'success', text: message }
    },

    starFillPct(n, score) {
      const fill = Math.min(1, Math.max(0, score - (n - 1)))
      return Math.round(fill * 100)
    },

    // ─── RECOVER ACCOUNT ────────────────────────────────────────
    openRecoverDialog() {
      this.recoverStep = 1
      this.recoverPhone = ''
      this.recoverCountryCode = 39
      this.recoverOtp = ''
      this.recoverOtpError = ''
      this.recoverOtpReady = false
      this.recoverSuccessMsg = ''
      this.dialog_recover = true
    },
    closeRecoverDialog() {
      this.dialog_recover = false
    },
    async recoverSendOtp() {
      this.recoverLoading = true
      try {
        const res = await this.$http.post('/booking/booking_stepper.php', {
          action: 'sendOtp',
          payload: {
            customerId:localStorage.getItem('customerId'),
            countryCode: this.recoverCountryCode,
            phone: this.recoverPhone.replace(/\s/g, ''),
          }
        })
        const newCsrf = res.headers['x-csrf-token']
        if (newCsrf) sessionStorage.setItem('csrf', newCsrf)
        if (res.data.errorid === '0') {
          this.recoverOtp = ''
          this.recoverOtpError = ''
          this.recoverOtpReady = false
          this.recoverStep = 2
          setTimeout(() => { this.recoverOtpReady = true }, 300)
        } else {
          this.recoverOtpError = res.data.message || 'Failed to send OTP.'
          this.recoverStep = 4
        }
      } catch (e) {
        console.error('recoverSendOtp error', e)
        this.recoverOtpError = 'Connection error. Please try again.'
        this.recoverStep = 4
      } finally {
        this.recoverLoading = false
      }
    },
    async recoverOnOtpInput(val) {
      if (!this.recoverOtpReady) return
      if (this.recoverLoading) return
      const digits = val ? String(val).replace(/-/g, '') : ''
      if (digits.length < 9) { this.recoverOtpError = ''; return }
      this.recoverLoading = true
      this.recoverOtpError = ''
      try {
        const res = await this.$http.post('/booking/booking_stepper.php', {
          action: 'recoverAccount',
          payload: {
            phone: this.recoverPhone.replace(/\s/g, ''),
            otp: digits,
            countryCode: this.recoverCountryCode,
            customerId: localStorage.getItem('customerId')
          }
        })
        const newJwt = res.headers['authorization']
        if (newJwt) {
          this.$http.defaults.headers.common['Authorization'] = newJwt
          sessionStorage.setItem('jwt', newJwt)
        }
        const newCsrf = res.headers['x-csrf-token']
        if (newCsrf) sessionStorage.setItem('csrf', newCsrf)
        if (res.data.errorid === '0' && res.data.payloads && res.data.payloads.rc > 0) {
          const customerId = res.data.payloads.customerId
          if (customerId) localStorage.setItem('customerId', customerId)
          //console.log(862,'infotab',customer)
          //this.customer.validated=1
          //console.log(865,'infotab',customer)
          //this.$emit('customer-updated', this.customer);

          this.recoverSuccessMsg = this.$t(this.page + '.Reservations recoveredsuccessfully') 
          this.recoverStep = 3
          setTimeout(() => { this.dialog_recover = false }, 1500)
          setTimeout(() => { this.detectUser(1) }, 500)
        } else {
          this.recoverOtpError = res.data.message || 'Invalid OTP. Please try again.'
          this.recoverStep = 4
        }
      } catch (e) {
        console.error('recoverOnOtpInput error', e)
        this.recoverOtpError = 'Connection error. Please try again.'
        this.recoverStep = 4
      } finally {
        this.recoverLoading = false
      }
    },
  }
}
</script>

<style scoped>
hr.fw {
  min-width: 100%;
  margin:0!important;
} 

.info-tab-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.info-scroll {
  background: #fff;
}

.hero-carousel-wrap {
  position: relative;
}

.hero-carousel-wrap ::v-deep .v-carousel {
  border-radius: 0;
}

.rating-badge {
  position: absolute;
  bottom: 12px;
  left: 12px;
  background: rgba(255,255,255,0.95);
  border-radius: 20px;
  padding: 4px 12px;
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.status-card {
  border-radius: 14px !important;
}
.status-card--error { background: #c62828 !important; }
.status-card--warning { background: #e65100 !important; }

.info-card {
  border-radius: 14px !important;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06) !important;
  overflow: hidden;
}

.info-row {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  gap: 12px;
}

.info-row--column {
  align-items: stretch;
  flex-direction: column;
}

.info-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #f2f2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.payment-icon {
  border: 1px solid #eee;
  border-radius: 4px;
}

/* Opening days dot grid */
.days-grid {
  padding-left: 42px;
}
.days-grid__header,
.days-grid__row {
  display: grid;
  grid-template-columns: 44px repeat(7, 1fr);
  align-items: center;
  gap: 2px;
}
.days-grid__day-label {
  font-size: 0.68rem;
  font-weight: 700;
  color: #999;
  text-align: center;
}
.days-grid__row-label {
  font-size: 0.72rem;
  color: #666;
}
.days-grid__row {
  margin-top: 4px;
}
.day-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin: 0 auto;
  display: block;
}
.day-dot--open {
  background: #000;
}
.day-dot--closed {
  background: #fff;
  border: 1.5px solid #ddd;
}

.custom-action-btn {
  border-radius: 10px !important;
}

.bottom-button-container2 {
  padding: 8px 16px 18px 16px;
  margin-bottom: 28px!important;
}

.bottom-button-container2 .v-btn {
  border-radius: 14px !important;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.15);
}

@media (max-width: 599px) {
  .bottom-button-container2 { padding: 8px 12px 18px; margin-bottom: 5px!important; }
}
@media (min-width: 600px) {
  .bottom-button-container2 { padding: 8px 24px 18px 24px; margin-bottom: 5px!important;}
}
</style>

<style scoped>
.clickable-slide {
  cursor: pointer;
}

.fullscreen-carousel-card {
  height: 100%;
  background: #000;
}

.fullscreen-carousel-close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 20;
  background: rgba(0, 0, 0, 0.5);
}

.advertiser-iframe-card {
  height: 100%;
  background: #000;
  display: flex;
  flex-direction: column;
}

.advertiser-iframe {
  flex: 1;
  width: 100%;
  height: 100%;
  border: none;
}

.advertiser-iframe-close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 20;
  background: rgba(0, 0, 0, 0.5);
}

/* Recover account dialog */
.recover-dialog {
  border-radius: 16px !important;
  border-color: #e0e0e0 !important;
}

.recover-dialog__title {
  display: flex;
  align-items: center;
  padding: 16px 16px 10px 16px !important;
}

.recover-dialog__steps {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: 6px 0 10px;
}

.recover-dialog__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ddd;
  transition: all 0.25s ease;
}

.recover-dialog__dot--active {
  background: #000;
  width: 22px;
  border-radius: 4px;
}

.recover-dialog__dot--done {
  background: #4caf50;
}

.recover-dialog__hint {
  display: flex;
  align-items: flex-start;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 8px 10px;
}

.recover-cta-btn {
  color: #555 !important;
}
</style>

<style scoped>
/* If using <style scoped> */
::v-deep .v-window__container,
::v-deep .v-window-item,
::v-deep .v-image {
  height: 100% !important;
}

::v-deep .v-image__image--cover {
  background-size: cover !important;
  background-position: center center !important;
}
</style>
<style scoped>
.hero-carousel-ratio {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 315 / 560 = 56.25% — ties height to width */
}

.hero-carousel-ratio ::v-deep .v-carousel {
  position: absolute;
  inset: 0;
  width: 100% !important;
  height: 100% !important;
}
</style>